<template>
    <AdminLayout>
        <div class="text-end">
            <button @click="addNewJudge" type="button" class="btn btn-sm btn-success"> + Add Judge</button>
        </div>
        <div class="table-responsive">
            <form v-on:submit.prevent="search">

                <table class="table align-middle">
                    <thead>
                        <tr>
                            <th class="text-center">Name</th>
                            <th class="text-center">Description</th>
                            <th class="text-center">Enabled</th>
                        </tr>
                        <tr>

                            <th>
                                <input v-model="judgesSearchObj.name" class="form-control" />
                            </th>
                            <th>
                                <input v-model="judgesSearchObj.description" class="form-control" />
                                <button type="submit" class="d-none" />
                            </th>
                            <th>
                                <input v-model="judgesSearchObj.isEnabled" class="form-control" />
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;" @click.prevent="getJudgeInfo(judge.id)" v-for="judge in judges"
                            :key="judge.id">
                            <td>{{ judge.name }}</td>
                            <td>{{ judge.description }}</td>
                            <td class="text-center">
                                <i v-if="judge.isEnabled" class="bi bi-check text-success"></i>
                                <i v-else class="bi bi-x text-danger"></i>
                            </td>
                            <td><button type="button" class="btn btn-sm btn-danger"
                                    @click.stop.prevent="deleteJudge(judge.id)">
                                    <i class="bi bi-trash"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </form>

        </div>
        <MediumSizedModal title="Contest Information" @close="toggleModal" :show="showModal">
            <JudgeInfo :id="selectedId" @next="handleNext" @prev="handlePrev" @reset="onReset" />
        </MediumSizedModal>
    </AdminLayout>
</template>

<script setup>
import JudgeInfo from '@/components/judges/JudgeInfo.vue';
import MediumSizedModal from '@/components/modals/MediumSizedModal.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import confirmationService from '@/services/confirmationService';
import judgeService from '@/services/judgeService';
import spinnerService from '@/services/spinnerService';
import toastService from '@/services/toastService';
import { onMounted, ref } from 'vue';

const judges = ref([]);
const judgesSearchObj = ref({});
const selectedId = ref('');
const showModal = ref(false);
const getJudgeInfo = async (id) => {
    selectedId.value = id;
    toggleModal();
}
const addNewJudge = () => {
    selectedId.value = '00000000-0000-0000-0000-000000000000';
    toggleModal();
}
const toggleModal = () => {
    showModal.value = !showModal.value;
};
const search = async () => {
    judges.value = await judgeService.search(judgesSearchObj.value);
}

const deleteJudge = async (id) => {
    const confirmed = await confirmationService.show("Are you sure you want to delete this judge?");
    if (!confirmed) return;
    spinnerService.show();
    const response = await judgeService.deleteJudge(id);
    if (response.success) {
        toastService.success("Judge removed successfully!");
        search();
    }
    else {
        toastService.error(response.message);
    }
    spinnerService.hide();
}

onMounted(() => {
    search();
});

</script>